module.exports = __webpack_public_path__ + "img/code-reviewer.96d405e9.jpeg";